import {
  Box,
  Text,
  GridItem,
} from "@chakra-ui/react";

export default function GridItemDetalhe({ label, value }: {label: string, value: any}) {
  if (!label && !value){
    return
  }
  return (
      <GridItem key={label}>
        <Box>
          <Text
            fontSize="xs"
            color="gray.500"
            mb={1}
            textTransform="uppercase"
          >
            {label}
          </Text>
          <Text fontSize="md" color="gray.800">
            {value}
          </Text>
        </Box>
      </GridItem>
  );
}